import React from 'react'
import { useField } from 'formik'
import { FieldWrapper } from './FieldWrapper'

import { InputDefaults, inputClasses } from './form-defaults'
import clsx from 'clsx'


const FormikTextInput = ({ className, name, label, helpText, errorClassName, unstyled = false, step, disabled = false, readOnly = false, required = false, type = 'text', placeholder = '', ariaLabel, wrapped = true }: {
  type?: string,
  step?: number,
  className?: string,
  required?: boolean,
} & InputDefaults<string | number>) => {
  const [field, meta] = useField(name)
  const error = meta.touched && meta.error ? meta.error : undefined;

  return (
    <FieldWrapper
      name={name}
      label={label}
      helpText={helpText}
      error={error}
      errorClassName={errorClassName}
      wrapped={wrapped}
    >
      <input
        {...field}
        readOnly={readOnly}
        disabled={disabled}
        step={step}
        type={type}
        placeholder={placeholder}
        required={required}
        aria-label={ariaLabel}
        aria-invalid={!!error}
        className={clsx(!unstyled && inputClasses(!!readOnly || !!disabled, false), className, error && "border-danger")}
      />
    </FieldWrapper>
  )
}


export default FormikTextInput;
